import {Component} from 'react'

import BaseStrategy from '../BaseStrategy.js'
import ReconcileForm from './ReconcileForm.js'
import EditForm from './EditForm.js'
import actions from '../../../../redux/actions/ui/dataImport/strategies/productFulfillmentStrategy.js'
import {getNounsFromValue} from '../../../../common/tokenizeOptions.js'

export default class ProductFulfillmentStrategy extends Component {
  render() {
    return (
      <BaseStrategy
        {...this.props}
        actions={actions}
        EditForm={EditForm}
        ReconcileForm={ReconcileForm}
      />
    )
  }
}

ProductFulfillmentStrategy.title = actions.title
const option = {
  value: 'update_product_fulfillment',
  display: 'Update Product Fulfillment',
  category: 'products',
  Component: ProductFulfillmentStrategy,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
ProductFulfillmentStrategy.option = option
